import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Divider, Stack, Typography } from '@mui/material';
import { getDefaultAlertProps } from '../../utils/utils';
import { MyAlert } from '../UI/MyAlert';
import { IAlertProps } from '../../interface/IAlertProps';
import { BackDropDiv } from '../backdrop/BackDropDiv';
import { IApiResult } from '../../interface/IApiResult';
import {
  API_STATUS_PROBLEM,
  LECTION_NAME,
  SECTION_NAME,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { RowSectionDivItem } from './RowSectionDivItem';
import { ContentDto } from '../../dto/ContentDto';
import { apiGetContent } from '../../service/apiGetContent';
import { MyTextFiled } from '../UI/MyTextField';
import { apiUpdateContent } from '../../service/apiUpdateContent';
import { MyButton } from '../UI/MyButton';
import { apiDeleteContent } from '../../service/apiDeleteContent';
import { DialogConfirmation } from '../confirmation/DialogConfirmation';
import { SectionDto } from '../../dto/SectionDto';
import { apiGetSections } from '../../service/apiGetSections';
import { apiCopyContent } from '../../service/apiCopyContent';
import { MAIN_ROUTE } from '../../constant/routes';
import { DialogAddTest } from '../dialog/DialogAddTest';

export const SectionDiv = () => {
  const navigate = useNavigate();
  const { section } = useParams();
  const [openDialog, setOpneDialog] = useState(false);
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [hasRequest, setHasRequest] = useState(false);
  const [checkHelper, setCheckHelper] = useState(false);
  const [contentDto, setContentDto] = useState<ContentDto>({
    id: -1,
    key: '',
    keyFormat: '',
    name: '',
    route: '',
    url: '',
    section: '',
  });
  const [contentDeleteDto, setContentDeleteDto] = useState<ContentDto>({
    id: -1,
    key: '',
    keyFormat: '',
    name: '',
    route: '',
    section: '',
    url: '',
  });
  const [contentTestDto, setContentTestDto] = useState<ContentDto>({
    id: -1,
    key: '',
    keyFormat: '',
    name: '',
    route: '',
    section: '',
    url: '',
  });
  const [contentDtos, setContentDtos] = useState<ContentDto[]>([]);
  const [backDrop, setBackDrop] = useState(false);

  const getContents = async (route: string) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetContent(route);
    if (apiResult.isSuccess) {
      setContentDtos(apiResult.data);
      setHasRequest(true);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const copyContents = async (route: string, routeFrom: string) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiCopyContent(route, routeFrom);
    if (apiResult.isSuccess) {
      getContents(route);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const [sectionDtos, setSectionDtos] = useState<SectionDto[]>([]);

  const getSections = async () => {
    const apiResult: IApiResult = await apiGetSections();
    if (apiResult.isSuccess) {
      setSectionDtos(apiResult.data);
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
  };

  const updateContent = async (route: string, dto?: ContentDto) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiUpdateContent(
      route,
      dto ?? contentDto
    );
    if (apiResult.isSuccess) {
      getContents(route);
      setContentDto({
        id: -1,
        key: '',
        keyFormat: '',
        name: '',
        route: '',
        section: '',
        url: '',
      });
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  const deleteContent = async (confirm: boolean) => {
    if (!confirm) {
      setOpenDialogConfirmation(false);
      return;
    }
    const apiResult: IApiResult = await apiDeleteContent(
      section ?? '',
      contentDeleteDto
    );
    if (apiResult.isSuccess) {
      getContents(section ?? '');
      setContentDeleteDto({
        id: -1,
        key: '',
        keyFormat: '',
        name: '',
        route: '',
        section: '',
        url: '',
      });
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setOpenDialogConfirmation(false);
  };

  const handleAdd = async () => {
    if (contentDto.key === '' || contentDto.name === '') {
      setCheckHelper(true);
      return;
    }
    await updateContent(section ?? '');
    setCheckHelper(false);
  };

  const handleOpenDialog = async (dto: ContentDto) => {
    setContentTestDto(dto);
    setOpneDialog(true);
  };

  const handleDelete = async (dto: ContentDto) => {
    setContentDeleteDto(dto);
    setOpenDialogConfirmation(true);
  };

  const handleEdit = (dto: ContentDto) => {
    const dto2 = dto;
    dto2.key = dto2.keyFormat;
    setContentDto(dto2);
  };

  const handleNavigate = (dto: ContentDto) => {
    localStorage.setItem(LECTION_NAME, `${dto.keyFormat} ${dto.name}`);
    // navigate(`${MAIN_ROUTE}/${section}/${dto.route}`);
    window.open(`${MAIN_ROUTE}/${section}/${dto.route}`, '_blank');
  };

  const handleReset = () => {
    setContentDto({
      id: -1,
      key: '',
      keyFormat: '',
      name: '',
      route: '',
      section: '',
      url: '',
    });
  };

  useEffect(() => {
    setContentDto({
      id: -1,
      key: '',
      keyFormat: '',
      name: '',
      route: '',
      section: '',
      url: '',
    });
    getSections();
    getContents(section ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Stack width="100%" alignItems="center">
      <BackDropDiv open={backDrop} />
      <MyAlert
        message={alertProps.message}
        severity={alertProps.severity}
        onClose={() => setAlertProps({ ...alertProps, message: '' })}
      />
      <Stack width="90%" padding="10px" spacing={0}>
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Typography
            style={{
              fontFamily: 'sans-serif',
              fontStyle: 'normal',
              fontWeight: 500,
              fontSize: '30px',
              color: '#000000',
              letterSpacing: 1,
            }}
            component="text"
          >
            {`${localStorage.getItem(SECTION_NAME)} - Структура`}
          </Typography>
          {!(contentDtos.length > 0) && hasRequest && (
            <Stack direction="row" spacing={1}>
              {sectionDtos.map(
                (item) =>
                  item.section !== section && (
                    <MyButton
                      text={`Скопировать предмет ${item.name}`}
                      background="purple"
                      width="310px"
                      height="30px"
                      onClick={() => copyContents(section ?? '', item.section)}
                    />
                  )
              )}
            </Stack>
          )}
        </Stack>
        <Divider />
        <Stack marginBottom="40px">
          <div> </div>
        </Stack>
        <Stack direction="row" spacing={1}>
          <MyTextFiled
            value={contentDto.key}
            onChange={(e) =>
              setContentDto({ ...contentDto, key: e.target.value })
            }
            width="310px"
            size="small"
            error={checkHelper}
            label="Пункт"
          />
          <MyTextFiled
            value={contentDto.name}
            onChange={(e) =>
              setContentDto({ ...contentDto, name: e.target.value })
            }
            size="small"
            error={checkHelper}
            label="Наименование раздела"
          />

          {contentDto.id === -1 && (
            <MyButton
              text="Добавить"
              width="150px"
              background="#9c27b0"
              height="50px"
              onClick={handleAdd}
            />
          )}
          {contentDto.id !== -1 && (
            <Stack direction="row" spacing={1}>
              <MyButton
                text="Сохранить"
                width="150px"
                background="#9c27b0"
                height="50px"
                onClick={handleAdd}
              />
              <MyButton
                text="Отмена"
                width="150px"
                background="#212121"
                height="50px"
                onClick={handleReset}
              />
            </Stack>
          )}
        </Stack>
        <Stack marginBottom="40px">
          <div> </div>
        </Stack>
        {contentDtos.map((item) => (
          <div>
            <RowSectionDivItem
              key={item.id}
              dto={item}
              onOpenDialog={handleOpenDialog}
              onClickNavigate={handleNavigate}
              onClickDelete={handleDelete}
              onClickEdit={handleEdit}
            />
            <Divider />
          </div>
        ))}
      </Stack>
      <DialogConfirmation
        open={openDialogConfirmation}
        message="Вы точно хотите удалить данный пункт?"
        onClose={deleteContent}
      />
      <DialogAddTest
        dto={contentTestDto}
        open={openDialog}
        onClose={() => setOpneDialog(false)}
      />
    </Stack>
  );
};
